import { axios } from "@/client/libs/axios";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { RateDto } from "libs/dto/src/rate";

const getRate = async (id: string) => {
  const response = await axios.get<RateDto, AxiosResponse<RateDto>>(`rates/${id}`);
  console.log(response.data);
  return response.data;
};

export const useRate = (id: string) => {
  const {
    data: rate,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["all-rate", id],
    queryFn: () => getRate(id),
    enabled: !!id,
  });
  return { rate, error, isLoading };
};
